import AppDispatcher from '../../../flux/dispatcher/dispatcher';
import Constant from '../constant/Constant';
import restClient from '../../MainFrame/action/APIClient';
import LogoutConstant from '../../MainFrame/constants/Constants';

var GetProfileSettingsAction = function () {

}


GetProfileSettingsAction.prototype = {

	getSettings: function (data) {
		restClient.getProfileSettings(data, function (error, response) {
			if (error) {
				// console.log("error", error);
				if (error.status === 401) {
					AppDispatcher.dispatch({
						actionType: LogoutConstant.UNAUTHORIZED_EXCEPTION,
						data: error
					});
				} else if (error.status === 403) {
					AppDispatcher.dispatch({
						actionType: Constant.PROFILE_SETTINGS_RECEIVED,
						data: error
					});
				} else if (error.status === 404) {
					AppDispatcher.dispatch({
						actionType: Constant.PROFILE_SETTINGS_ABSENT,
						data: error
					});
				}
			} else {
				// console.log("response of get profile settings", response)
				AppDispatcher.dispatch({
					actionType: Constant.PROFILE_SETTINGS_RECEIVED,
					data: response
				});
			}
		})
	}
}

export default new GetProfileSettingsAction();